"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sellingResourceBeet = exports.SellingResource = void 0;
const beet = __importStar(require("@metaplex-foundation/beet"));
const beetSolana = __importStar(require("@metaplex-foundation/beet-solana"));
const SellingResourceState_1 = require("../types/SellingResourceState");
const sellingResourceDiscriminator = [15, 32, 69, 235, 249, 39, 18, 167];
class SellingResource {
    constructor(store, owner, resource, vault, vaultOwner, supply, maxSupply, state) {
        this.store = store;
        this.owner = owner;
        this.resource = resource;
        this.vault = vault;
        this.vaultOwner = vaultOwner;
        this.supply = supply;
        this.maxSupply = maxSupply;
        this.state = state;
    }
    static fromArgs(args) {
        return new SellingResource(args.store, args.owner, args.resource, args.vault, args.vaultOwner, args.supply, args.maxSupply, args.state);
    }
    static fromAccountInfo(accountInfo, offset = 0) {
        return SellingResource.deserialize(accountInfo.data, offset);
    }
    static async fromAccountAddress(connection, address) {
        const accountInfo = await connection.getAccountInfo(address);
        if (accountInfo == null) {
            throw new Error(`Unable to find SellingResource account at ${address}`);
        }
        return SellingResource.fromAccountInfo(accountInfo, 0)[0];
    }
    static deserialize(buf, offset = 0) {
        return exports.sellingResourceBeet.deserialize(buf, offset);
    }
    serialize() {
        return exports.sellingResourceBeet.serialize({
            accountDiscriminator: sellingResourceDiscriminator,
            ...this,
        });
    }
    static byteSize(args) {
        const instance = SellingResource.fromArgs(args);
        return exports.sellingResourceBeet.toFixedFromValue({
            accountDiscriminator: sellingResourceDiscriminator,
            ...instance,
        }).byteSize;
    }
    static async getMinimumBalanceForRentExemption(args, connection, commitment) {
        return connection.getMinimumBalanceForRentExemption(SellingResource.byteSize(args), commitment);
    }
    pretty() {
        return {
            store: this.store.toBase58(),
            owner: this.owner.toBase58(),
            resource: this.resource.toBase58(),
            vault: this.vault.toBase58(),
            vaultOwner: this.vaultOwner.toBase58(),
            supply: this.supply,
            maxSupply: this.maxSupply,
            state: 'SellingResourceState.' + SellingResourceState_1.SellingResourceState[this.state],
        };
    }
}
exports.SellingResource = SellingResource;
exports.sellingResourceBeet = new beet.FixableBeetStruct([
    ['accountDiscriminator', beet.uniformFixedSizeArray(beet.u8, 8)],
    ['store', beetSolana.publicKey],
    ['owner', beetSolana.publicKey],
    ['resource', beetSolana.publicKey],
    ['vault', beetSolana.publicKey],
    ['vaultOwner', beetSolana.publicKey],
    ['supply', beet.u64],
    ['maxSupply', beet.coption(beet.u64)],
    ['state', SellingResourceState_1.sellingResourceStateBeet],
], SellingResource.fromArgs, 'SellingResource');
//# sourceMappingURL=SellingResource.js.map